import { Observable } from 'rxjs/Observable';
import { switchMap, take } from 'rxjs/operators';
import { Collections } from '../collections.model';
import { StoreBackend } from './backend';
import { Reference } from './store.model';

export class ListObservable<K extends keyof Collections> extends Observable<
  ReadonlyArray<Collections[K]>
> {
  constructor(
    private ref$: Observable<Reference<K>>,
    private storeBackend: StoreBackend,
    source: Observable<ReadonlyArray<Collections[K]>>,
  ) {
    super();
    this.source = source;
  }

  push(object: Collections[K]): Promise<boolean> {
    return this.ref$
      .pipe(take(1), switchMap(ref => this.storeBackend.push(ref, object)))
      .toPromise();
  }

  set(id: number | string, object: Collections[K]): Promise<boolean> {
    return this.ref$
      .pipe(take(1), switchMap(ref => this.storeBackend.set(ref, id, object)))
      .toPromise();
  }

  update(
    id: number | string,
    object: Partial<Collections[K]>,
  ): Promise<boolean> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref => this.storeBackend.update(ref, id, object)),
      )
      .toPromise();
  }

  remove(id: number | string): Promise<boolean> {
    return this.ref$
      .pipe(take(1), switchMap(ref => this.storeBackend.delete(ref, id)))
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/list-observable.ts